import { combineReducers } from "redux";
import { jwtAuthreducer } from "./auth_reducer";
import { branchReducer } from "./branch_reducer";
import { departmentReducer } from "./department_reducer";
import { rolesReducer } from "./roles_reducer";
import { designationReducer } from "./designation_reducer";
import { stateReducer } from "./state_reducer";
import { countryReducer } from "./country_reducer";
import { zoneReducer } from "./zone_reducer";
import { investigationReducer } from "./investigation_reducer";
import { dropListReducer } from "./drop_list_reducer";
import { newRegistrationReducer } from "./new_registration_reducer";
import { RegistrationSerachReducer } from "./registration_serach_reducer";
import { observationReducer } from "./observation_reducer";
import resultEntryObservationReducer from "./result_entry_observation_reducer";

const reducers = combineReducers({
    jwtAuthreducer,
    branchReducer,
    departmentReducer,
    rolesReducer,
    designationReducer,
    stateReducer,
    countryReducer,
    zoneReducer,
    investigationReducer,
    dropListReducer,
    newRegistrationReducer,
    RegistrationSerachReducer,
    observationReducer,
    resultEntryObservationReducer
})

export default reducers;
